<template>
  <v-client-table
    :data="signatures"
    :columns="columns"
    :options="options">
    <template slot="dateEnvoie" slot-scope="props">
      {{ formatDate(props.row.dateEnvoie) }}
    </template>
    <template slot="contratEtatSignature" slot-scope="props">
      {{ getEtatLibelle(props.row.contratEtatSignature) }}
    </template>
    <template slot="envoyeur" slot-scope="props">
      {{ getUser(props.row.utilisateur) }}
    </template>
    <template slot="dateSignature" slot-scope="props">
      {{ formatDate(props.row.dateSignature) }}
    </template>
    <template slot="contact" slot-scope="props">
      <router-link-blank v-if="props.row.contactId"
        :to="{ name: 'c.bodac.clients/contacts-contacts',
          params: {id: props.row.contactId}}"
        :message="props.row.contact.nom + ' ' + props.row.contact.prenom"/>
    </template>
  </v-client-table>
</template>

<script>
import formatDate from '@/services/general/formatDate';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import cloneDeep from 'lodash/cloneDeep';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import { LISTE_ETAT_CONTRAT_SIGNATURE } from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    signatures: {
      type: Array,
      required: true,
    },
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    columns() {
      return ['dateEnvoie', 'contratEtatSignature', 'envoyeur', 'dateSignature', 'contact'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateEnvoie: this.$t('detailDevis.signature.tab.dateEnvoie'),
          contratEtatSignature: this.$t('detailDevis.signature.tab.contratEtatSignature'),
          envoyeur: this.$t('detailDevis.signature.tab.envoyeur'),
          dateSignature: this.$t('detailDevis.signature.tab.dateSignature'),
          contact: this.$t('detailDevis.signature.tab.contact'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {},
        sortable: ['dateEnvoie', 'contratEtatSignature', 'envoyeur', 'dateSignature', 'contact'],
        orderBy: {
          column: 'dateEnvoie',
          ascending: false,
        },
      };
    },
  },
  methods: {
    formatDate(date) {
      return formatDate(date);
    },
    getUser(user) {
      if (user) {
        return nomPrenomGetter(user);
      }
      return '';
    },
    getEtatLibelle(etatContrat) {
      const find = LISTE_ETAT_CONTRAT_SIGNATURE.find(etat => etat.code === etatContrat);
      return this.$t(find?.libelle) || null;
    },
  },
};
</script>

<style>

</style>
